const taskActionTypes =  {    
    RETRIEVED_TASK_LIST: "RETRIEVED_TASK_LIST",
    RETRIEVED_TASK_STATUS_LIST: "RETRIEVED_TASK_STATUS_LIST",
    STARTED_SCHEDULE: "STARTED_SCHEDULE",
    STOPPED_SCHEDULE: "STOPPED_SCHEDULE",
    RETRIEVED_SCHEDULE_SETTINGS: "RETRIEVED_SCHEDULE_SETTINGS",
    UPDATED_SCHEDULE_SETTINGS: "UPDATED_SCHEDULE_SETTINGS",
    RETRIEVED_SCHEDULE_HISTORY: "RETRIEVED_SCHEDULE_HISTORY",
    RETRIEVED_SCHEDULE_ITEMS: "RETRIEVED_SCHEDULE_ITEMS",
    RETRIEVED_SERVER_LIST: "RETRIEVED_SERVER_LIST",
    RETRIEVED_SCHEDULE_ITEM: "RETRIEVED_SCHEDULE_ITEM",
    DELETED_SCHEDULE_ITEM: "DELETED_SCHEDULE_ITEM",
    CREATED_SCHEDULE_ITEM: "CREATED_SCHEDULE_ITEM",
    UPDATED_SCHEDULE_ITEM: "UPDATED_SCHEDULE_ITEM",
    EXECUTED_SCHEDULE_ITEM: "EXECUTED_SCHEDULE_ITEM",
    SCHEDULE_ITEM_SETTINS_CLIENT_MODIFIED: "SCHEDULE_ITEM_SETTINS_CLIENT_MODIFIED",
    CANCELED_SCHEDULE_ITEM_SETTINS_CLIENT_MODIFIED: "CANCELED_SCHEDULE_ITEM_SETTINS_CLIENT_MODIFIED",
    UPDATED_SCHEDULE_SETTINGS_PENDING: "UPDATED_SCHEDULE_SETTINGS_PENDING"
};
export default taskActionTypes;
